import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { createMcpServer } from '@/services/mcp-gateway';
import type { CreateMcpServerInput } from '@/services/mcp-gateway';

export function useCreateMcpServer() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: (input: CreateMcpServerInput) => createMcpServer(input, orgId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['mcp-servers', orgId] });
      // A new catalog server is a new preset a member can connect from Tools.
      void queryClient.invalidateQueries({ queryKey: ['mcp-connector-presets', orgId] });
    },
  });
}
